<template>
	<div>
		<CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
			<template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Folio</th>
                <th :class="StyleTh">Fecha Cotización</th>
                <th :class="StyleTh">Tipo Boda</th>
                <th :class="StyleTh">Estatus</th>
                <th :class="StyleTh">Total</th>
                <th :class="StyleTh+' text-center'">Acciones</th>
			</template>

			<template slot="body">
				<tr v-for="(lista,index) in ListaArrayRows" :key="index">
					<td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                    <td><h6 :class="StylePr">{{lista.Folio}}</h6></td>
                    <td><p :class="StyleTd">{{lista.FechaCotizacion}}</p></td>
                    <td><p v-if="lista.tipoevento" :class="StyleTd">{{lista.tipoevento.Nombre}}</p></td>
                    <td>
                        <p :class="StyleTd">
                            <span v-if="lista.Estatus == 0">Creado</span>
                            <span v-else-if="lista.Estatus == 3">Confirmado</span>
                        </p>
                    </td>
                    <td><p :class="StyleTd">{{$formatNumber(lista.TotalGlobal,'$')}}</p></td>
                    
					<td class="align-middle text-end">
						<CBtnAccion  :pShowBtnEdit="true" :pShowBtnDelete="false" :pIsModal="false" :pId="lista.IdCotizacion" :pEmitSeccion="ConfigList.EmitSeccion" :pGoRoute="ConfigList.GoRoute" :segurity="segurity">
							<template slot="btnaccion">
                                <CMoreButtonsL>
							        <template slot="bodyBtnsL">
                                        <li @click="GetContratoPdf(lista)">
                                            <a class="dropdown-item">
                                                <i class="fa fa-file-pdf"></i> Contrato
                                            </a>
                                        </li>
                                        
                                        <template v-if="lista.Estatus<4">
                                            <template v-if="segurity.SendQuotation">
                                                <li @click="EvniarCorreo(lista)">
                                                    <a class="dropdown-item">
                                                        <i class="fa fa-file"></i> Enviar Cotización
                                                    </a>
                                                </li>
                                            </template>

                                            <template v-if="segurity.ConfirmQuotation">
                                                <li @click="ConfirmarEventos(lista)">
                                                    <a class="dropdown-item">
                                                        <i class="fa fa-check"></i> Confirma Eventos
                                                    </a>
                                                </li>
                                            </template>
                                        </template>
                                    </template>
                                </CMoreButtonsL>

                            </template>
						</CBtnAccion>     
					</td>
				</tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="7"></CSinRegistros>
			</template>
		</CList>

        <CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
			<template slot="Form">
				<Form :poBtnSave="oBtnSave"></Form>
			</template>
		</CModal>

	</div>
</template>
<script>

import Form from '@/views/modulos/crm/cotizacion/ViewContrato.vue';
const EmitEjecuta2 = 'seccionContrato';

import moment from 'moment';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionCotizacion';

export default {
    name: 'ListaCotizacion',
    props: ['objEnviado'],
    components: {
        Form,
    },
    data() {
        return {
            ConfigList:{
                Title: 'Cotizaciones',
                IsModal: false,
                ShowLoader: true,
                ShowFiltros: false,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                BtnNewShow: false,
                TitleFirst: 'Prospectos',
                GoRoute: 'formCotizacion',
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
            },
            ConfigModal:{
                ModalTitle: "Contrato",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta2,
                ModalSize: 'sm',
            },
            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta2,
                ShowBtnCancel: false,
                TxtBtnSave: 'Ver Contrato',
                IconoSave: 'fa fa-eye'
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            ListaHeader: [],
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            ObjCliente: {},
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            await this.$http.get("cotizaciones",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                    IdCliente: this.ObjCliente.IdCliente,
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Eliminar(Id)
        {
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('cotizaciones/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Regresar() {
            this.$router.push({name:'prospectos',params:{}});
        },
        ConfirmarEventos(item)
        {
            this.$swal(
            {
                title: '<h2 style="font-size:25px; font-weight: 700;">¿Desea Confirmar los eventos?</h2>',
                text: 'Esta acción no se podra revertir ',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Continuar',
                cancelButtonText: 'Cancelar',
                showCloseButton: true,
                showLoaderOnConfirm: true,
                confirmButtonColor: '#0096ED',
                cancelButtonColor: '#b92e27',
            }).then((result) =>
            {
                if(result.value)
                {
                    this.$http.get('cotzConfirmarEvento',{
                        params:{
                            IdCotizacion: item.IdCotizacion,
                            Confirm: 1,
                        }
                    }).then((res) => {
                        this.$swal('Eventos Confirmados','','success');
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        GetContratoPdf(item)
        {
            this.bus.$emit('NewModal_'+EmitEjecuta2,item);
        },
        EvniarCorreo(item)
        {
            this.$swal(
            {
                title: '<h2 style="font-size:25px; font-weight: 700;">¿Desea enviar el contrato al porspecto?</h2>',
                text: 'Recuerde que el porspecto debe tener registrado un correo eléctronico',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Continuar',
                cancelButtonText: 'Cancelar',
                showCloseButton: true,
                showLoaderOnConfirm: true,
                confirmButtonColor: '#0096ED',
                cancelButtonColor: '#b92e27',
            }).then((result) =>
            {
                if(result.value)
                {
                    this.ConfigList.ShowLoader = true;
                    this.$http.get('enviarCorreoCotizacion',{
                        params:{
                            IdCotizacion: item.IdCotizacion
                        }
                    }).then((res)=> {
                        this.$toast.success('Correo Enviado');
                    }).catch(err => {
                        this.$toast.warning('El correo no pudo ser enviado');
                    }).finally(()=>{
                        this.ConfigList.ShowLoader = false;
                    });
                }
            });
        },
    },
    created()
    {
        if(this.objEnviado!=undefined){
            sessionStorage.setItem('objCliente',JSON.stringify(this.objEnviado));
        }

        this.ObjCliente = JSON.parse(sessionStorage.getItem('objCliente'));

        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
